module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dates"
  }, [(_vm.window && _vm.window.startDate) ? _c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.window.startDate)))]) : _c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.forecast.startDate)))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "svg"
    }
  }, [_c('CalendarIcon', {
    attrs: {
      "color": _vm.iconColor
    }
  })], 1), _vm._v(" "), (_vm.window && _vm.window.endDate) ? _c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.window.endDate)))]) : _c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.forecast.endDate)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b241303","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/DateInfo.vue
// module id = 3286
// module chunks = 0